class KyBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.threshold = window.innerHeight;
    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button?.addEventListener('click', this.onClick);

    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.button?.removeEventListener('click', this.onClick);
  }

  onScroll() {
    const scrolled = window.scrollY || document.documentElement.scrollTop;

    if (scrolled > this.threshold) {
      this.setAttribute('data-visible', '');
    } else {
      this.removeAttribute('data-visible');
    }
  }

  onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

if (!customElements.get('ky-back-to-top')) {
  customElements.define('ky-back-to-top', KyBackToTop);
}
